<template>
    <div class="www pt-2 pb-2 select-none">
        <div class="flex items-start justify-between">
            <div class="text-sm leading-6 font-medium text-gray-700">
                {{ t('templatePadding') }}
            </div>
            <div class="flex h-6 items-center pl-2">
                <input
                    id="easy-config"
                    v-model="colSliderConfig.advancedConfig"
                    name="easy-config"
                    type="checkbox"
                    class="h-4 w-4 rounded-sm border-gray-300 text-blue-600 focus:ring-blue-600"
                    :disabled="!stateRepository.states.padding"
                />
                <label
                    for="easy-config"
                    :class="[
                        !stateRepository.states.padding
                            ? 'cursor-not-allowed text-gray-400'
                            : 'cursor-pointer text-gray-900',
                        'ml-2 text-sm leading-6 font-medium',
                    ]"
                >
                    {{ t('templatePaddingAdvanced') }}
                </label>
            </div>
        </div>
    </div>

    <div
        v-show="!colSliderConfig.advancedConfig"
        class="www pt-2 pr-2 pb-6 pl-2 select-none"
    >
        <div class="py-4">
            <div class="tw-slider-primary">
                <Vue3Slider
                    v-model="colSliderConfig.padding"
                    color="var(--slider-color)"
                    track-color="var(--slider-track)"
                    :min="colSliderConfig.min"
                    :max="colSliderConfig.max"
                    :tooltip="true"
                    :handle-scale="2.1"
                    tooltip-text="%vpx"
                    tooltip-color="var(--slider-color)"
                    tooltip-text-color="var(--slider-track)"
                    :always-show-handle="true"
                    :flip-tooltip="true"
                    :disabled="!stateRepository.states.padding"
                    @drag-end="easyUpdate()"
                />
            </div>
        </div>
    </div>
    <div
        v-show="colSliderConfig.advancedConfig"
        class="www pt-2 pr-2 pb-6 pl-2 select-none"
    >
        <div class="block text-sm font-medium text-gray-700">
            {{ t('templatePaddingAdvancedTop') }}
        </div>
        <div class="py-4">
            <div class="tw-slider-primary">
                <Vue3Slider
                    v-model="colSliderConfig.paddingTop"
                    color="var(--slider-color)"
                    track-color="var(--slider-track)"
                    :min="colSliderConfig.min"
                    :max="colSliderConfig.max"
                    :tooltip="true"
                    :handle-scale="2.1"
                    tooltip-text="%vpx"
                    tooltip-color="var(--slider-color)"
                    tooltip-text-color="var(--slider-track)"
                    :always-show-handle="true"
                    :flip-tooltip="true"
                    :disabled="!stateRepository.states.padding"
                    @drag-end="easyUpdate()"
                />
            </div>
        </div>
    </div>
    <div
        v-show="colSliderConfig.advancedConfig"
        class="www pt-2 pr-2 pb-6 pl-2 select-none"
    >
        <div class="block text-sm font-medium text-gray-700">
            {{ t('templatePaddingAdvancedRight') }}
        </div>
        <div class="py-4">
            <div class="tw-slider-primary">
                <Vue3Slider
                    v-model="colSliderConfig.paddingRight"
                    color="var(--slider-color)"
                    track-color="var(--slider-track)"
                    :min="colSliderConfig.min"
                    :max="colSliderConfig.max"
                    :tooltip="true"
                    :handle-scale="2.1"
                    tooltip-text="%vpx"
                    tooltip-color="var(--slider-color)"
                    tooltip-text-color="var(--slider-track)"
                    :always-show-handle="true"
                    :flip-tooltip="true"
                    :disabled="!stateRepository.states.padding"
                    @drag-end="easyUpdate()"
                />
            </div>
        </div>
    </div>
    <div
        v-show="colSliderConfig.advancedConfig"
        class="www pt-2 pr-2 pb-6 pl-2 select-none"
    >
        <div class="block text-sm font-medium text-gray-700">
            {{ t('templatePaddingAdvancedBottom') }}
        </div>
        <div class="py-4">
            <div class="tw-slider-primary">
                <Vue3Slider
                    v-model="colSliderConfig.paddingBottom"
                    color="var(--slider-color)"
                    track-color="var(--slider-track)"
                    :min="colSliderConfig.min"
                    :max="colSliderConfig.max"
                    :tooltip="true"
                    :handle-scale="2.1"
                    tooltip-text="%vpx"
                    tooltip-color="var(--slider-color)"
                    tooltip-text-color="var(--slider-track)"
                    :always-show-handle="true"
                    :flip-tooltip="true"
                    :disabled="!stateRepository.states.padding"
                    @drag-end="easyUpdate()"
                />
            </div>
        </div>
    </div>
    <div
        v-show="colSliderConfig.advancedConfig"
        class="www pt-2 pr-2 pb-6 pl-2 select-none"
    >
        <div class="block text-sm font-medium text-gray-700">
            {{ t('templatePaddingAdvancedLeft') }}
        </div>
        <div class="py-4">
            <div class="tw-slider-primary">
                <Vue3Slider
                    v-model="colSliderConfig.paddingLeft"
                    color="var(--slider-color)"
                    track-color="var(--slider-track)"
                    :min="colSliderConfig.min"
                    :max="colSliderConfig.max"
                    :tooltip="true"
                    :handle-scale="2.1"
                    tooltip-text="%vpx"
                    tooltip-color="var(--slider-color)"
                    tooltip-text-color="var(--slider-track)"
                    :always-show-handle="true"
                    :flip-tooltip="true"
                    :disabled="!stateRepository.states.padding"
                    @drag-end="easyUpdate()"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { reactive, watch } from 'vue';
    import Vue3Slider from 'vue3-slider';

    defineExpose({
        name: 'PaddingWidget',
    });

    const props = defineProps({
        members: {
            type: Object,
            required: true,
        },
        stateRepository: {
            type: Object,
            required: true,
        },
    });

    const stateRepository = props.stateRepository;
    const colSliderConfig = reactive({
        min: 0,
        max: 200,
        advancedConfig: false,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        padding: 0,
    });

    const members = props.members;
    const allEqual = (arr) => arr.every((val) => val === arr[0]);

    if (
        allEqual([
            members.paddingTop,
            members.paddingRight,
            members.paddingBottom,
            members.paddingLeft,
        ])
    ) {
        colSliderConfig.advancedConfig = false;
    } else {
        colSliderConfig.advancedConfig = true;
    }

    colSliderConfig.paddingTop = parseInt(members.paddingTop) || 0;
    colSliderConfig.paddingRight = parseInt(members.paddingRight) || 0;
    colSliderConfig.paddingBottom = parseInt(members.paddingBottom) || 0;
    colSliderConfig.paddingLeft = parseInt(members.paddingLeft) || 0;
    colSliderConfig.padding = parseInt(members.paddingTop) || 0;

    const easyUpdate = () => {
        ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'].map((item) => {
            if (!colSliderConfig.advancedConfig) {
                colSliderConfig[item] = colSliderConfig.padding;
            }
            members[item] = `${colSliderConfig[item]}px`;
        });
    };
</script>
